import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Auth0Service } from '../auth0/auth0.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(
    private router: Router,
    private auth0Service: Auth0Service
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth0Service.isAuthenticated()) {
      return true;
    }
    // localStorage.clear();
    this.router.navigate(['']);
    return false;
  }
}